var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edr__Type=EDR",
    className: "edr__Type=EDR"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edr__Vector",
    className: "edr__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.352 16.646c.025 1.143.139 1.715.365 2.059.215.326.604.545 1.592.759h15.345c.926-.185 1.338-.416 1.577-.767.244-.359.382-.948.415-2.051H14.5c-.494.774-1.45 1.245-2.483 1.245-1.032 0-1.988-.471-2.483-1.245H2.352Zm-1.14-.279a.85.85 0 0 1 .85-.857h7.625c.357 0 .631.217.769.464.234.421.812.782 1.562.782s1.329-.36 1.562-.782a.886.886 0 0 1 .77-.464h7.587a.85.85 0 0 1 .85.86c-.016 1.29-.143 2.267-.617 2.965-.5.737-1.3 1.044-2.295 1.242a1.133 1.133 0 0 1-.22.022H4.31c-.08 0-.16-.008-.238-.025-1.015-.22-1.819-.51-2.302-1.245-.454-.69-.545-1.664-.556-2.962Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.496 5.532c0-.941.763-1.703 1.703-1.703h15.603c.94 0 1.703.762 1.703 1.703v10.547H20.37V5.532a.568.568 0 0 0-.568-.568H4.199a.568.568 0 0 0-.568.567V16.08H2.496V5.532Z",
    clipRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdr);
export default __webpack_public_path__ + "static/media/EDR.1e7284250eb361d8b8a63f850a1da7fe.svg";
export { ForwardRef as ReactComponent };